import styled from 'styled-components';

/**
 * Layout wrapper for the SPEI wordmark.
 *
 * Purely structural — the mark carries its own brand colours (see `SpeiLogo`), and there is no
 * background: it sits directly on the checkout pane rather than on the plate the two-tone mark
 * used to need for contrast.
 */
export const LogoWrap = styled.span`
  display: inline-flex;
  align-items: center;
  line-height: 0;
`;
